import { isIos } from "../env";

export const hslColorName = (key: string) => {
  if (key.startsWith("N")) {
    return "color-" + key;
  }

  return "color-" + key.replace(/((?!^)[A-Z])/g, "-$1").toLowerCase();
};

export const hslNewColorName = (key: string, theme: string) => {
  const lightThemeColorRenaming = {
    gx_no_100: "N00",
    gx_no_98: "N12",
    gx_no_96: "N08",
    gx_no_92: "N04",
    gx_no_90: "N20",
    gx_no_88: "N16",
    gx_no_80: "N32",
    gx_no_40: "N59",
    gx_no_24: "N77",
    gx_no_00: "N100",
  };

  if (
    theme === "light" &&
    (isIos || !window.oprt?.gxCornerConfig?.colors) &&
    key.includes("gx_no_")
  ) {
    if (lightThemeColorRenaming[key]) {
      return `color-${lightThemeColorRenaming[key]}`;
    }
  }

  if (theme === "light" && key.includes("gx_no_100")) {
    return "color-N00";
  }

  if (theme === "light" && key.includes("gx_no_00")) {
    return "color-N100";
  }

  return (
    "color-" +
    key
      .replace(/((?!^)[A-Z])/g, "-$1")
      .replace("gx_no_", "N")
      .replace("gx_accent_l_", "A")
      .replace("gx_", "")
      .replaceAll("_", "-")
  );
};

export const hslColorStr = ({ h, s, l }: { h: number; s: number; l: number }) =>
  `${h} ${s}% ${l}%`;

export const hslNewColorStr = ({ h, s, l }: { h: number; s: number; l: number }) =>
  `${h.toFixed(0)} ${(s * 100).toFixed(0)}% ${(l * 100).toFixed(0)}%`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isHsl = (value: any): value is { h: number; s: number; l: number } => {
  if (!value) {
    return false;
  }

  const { h, s, l } = value;

  return [h, s, l].every((val) => typeof val === "number" && isFinite(val));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isHslNewColors = (value: {
  h: number;
  s: number;
  l: number;
}): value is { h: number; s: number; l: number } => {
  if (!value) {
    return false;
  }

  const { h, s, l } = value;

  return [h, s, l].every((val) => typeof val === "number" && isFinite(val));
};

export const hslColors = (colors: Record<string, { h: number; s: number; l: number }>) =>
  Object.fromEntries(
    Object.entries(colors)
      .filter(([, value]) => isHsl(value))
      .map(([key, value]) => [hslColorName(key), hslColorStr(value)]),
  );

export const hslNewColors = (
  colors: Record<string, { h: number; s: number; l: number }>,
  theme: string,
) =>
  Object.fromEntries(
    Object.entries(colors)
      .filter(([, value]) => isHslNewColors(value))
      .map(([key, value]) => [hslNewColorName(key, theme), hslNewColorStr(value)]),
  );
